import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { RapportIncidentTypeIncident } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-rapport-incident-secours-multi-select',
  templateUrl: './rapport-incident-secours-multi-select.component.html',
  styleUrls: ['./rapport-incident-secours-multi-select.component.css']
})
export class RapportIncidentSecoursMultiSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('secoursTree') secoursTree: DxTreeViewComponent;

  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() SecoursTypesIds: number[];
  @Input() titleNull: string;
  @Output() SecoursTypeIdsChange = new EventEmitter<number[]>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  SecoursTypes: any[] = [];
  ColumnName = [];

  p: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translateService: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translateService.getBrowserLang());
  }

  ngOnInit() {
    this.SecoursTypes.push({id: 0, name: this.translateService.instant('Rapports.RapportsIncidents.SecoursType.Pompier')});
    this.SecoursTypes.push({id: 1, name: this.translateService.instant('Rapports.RapportsIncidents.SecoursType.Police')});
    this.SecoursTypes.push({id: 2, name: this.translateService.instant('Rapports.RapportsIncidents.SecoursType.Ambulance')});

    if (this.SecoursTypesIds) {
      this.updateSelection(this.secoursTree?.instance);
    }
  }

  onLieuSelectionChanged(e) {
    this.SecoursTypesIds = [... e.component.getSelectedNodeKeys()];
    if (this.InitId != this.SecoursTypesIds && !!this.cell) {
      this.cell.setValue(this.SecoursTypesIds);
    }
    this.SecoursTypeIdsChange.emit(this.SecoursTypesIds);
  }

  onContentReady(e) {
    this.updateSelection(e.component);
  }

  updateSelection(secoursType) {
    let secoursTypesIds = [...this.SecoursTypesIds];
    if (!secoursType) return;

    if(this.SecoursTypesIds) {
      secoursType.unselectAll();
      secoursTypesIds.forEach((value) => {
        let secoursToSelect = this.SecoursTypes.filter(p => p.id == value);
        secoursType.selectItem(secoursToSelect);
      });
    }
  }

  onOpened() {
    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}

